import {get} from "lodash"
import BaseService from "./Base"

class SmsService extends BaseService {
    async me(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/me`, data, params)
        return get(response, "data.data", [])
    }

    async assignNumbers(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/assign`, data, params)
        return get(response, "data.data", [])
    }

    async editNumbers(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/edit`, data, params)
        return get(response, "data.data", [])
    }

    async getNumbers(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/list`, data, params)
        return get(response, "data", [])
    }

    async getDialerSettings(smsPhoneNumbersId: number, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/dialer-settings/get`, {smsPhoneNumbersId}, params)
        return get(response, "data.data", null)
    }

    async updateDialerSettings(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/dialer-settings/update`, data, params)
        return get(response, "data.data", null)
    }

    async generateVoicemail(data, params = {}) {
        const response = await this.post(`/v3/sms/phone-numbers/dialer-settings/generate-voicemail`, data, params)
        return get(response, "data.data", null)
    }
}

export default SmsService
